import * as React from 'react';
import { Stack } from '@fragments-sdk/ui';
import { DashboardLayout, type DashboardLayoutProps } from './DashboardLayout';
import {
  WorkspacePage,
  WorkspacePageHeader,
  type WorkspacePageHeaderProps,
} from './WorkspacePage';

export interface StatusDashboardChromeProps {
  className: string;
  bodyClassName: string;
  header: WorkspacePageHeaderProps;
  children: React.ReactNode;
}

export function StatusDashboardChrome({
  className,
  bodyClassName,
  header,
  children,
}: StatusDashboardChromeProps) {
  return (
    <WorkspacePage className={className}>
      <Stack gap="lg">
        <WorkspacePageHeader {...header} />
        <Stack gap="xl" className={bodyClassName}>
          {children}
        </Stack>
      </Stack>
    </WorkspacePage>
  );
}

export interface StatusDashboardPageProps
  extends
    StatusDashboardChromeProps,
    Pick<DashboardLayoutProps, 'activeNav' | 'flush'> {}

export function StatusDashboardPage({
  activeNav,
  flush = true,
  ...chromeProps
}: StatusDashboardPageProps) {
  return (
    <DashboardLayout activeNav={activeNav} flush={flush}>
      <StatusDashboardChrome {...chromeProps} />
    </DashboardLayout>
  );
}
